import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'

export const APP_SETTING_ACTION = {
  DETECT_DEVICE: 'DETECT_DEVICE',
  GET_APP_SETTING: 'GET_APP_SETTING',
  SWITCH_LANGUAGE: 'SWITCH_LANGUAGE',
  SWITCH_THEME: 'SWITCH_THEME',
  SHOW_TOAST: 'SHOW_TOAST',
  TOGGLE_QUOTE: 'TOGGLE_QUOTE',
  SWITCH_STOCK_SETTING: 'SWITCH_STOCK_SETTING',
  SWITCH_MENU_CONTROL: 'SWITCH_MENU_CONTROL',
  TOGGLE_MENU_MOBILE: 'TOGGLE_MENU_MOBILE',
  SWITCH_MODE: 'SWITCH_MODE',
  IDTYPE_LIST:'IDTYPE_LIST',
  SET_ACCESSIBILITY: 'SET_ACCESSIBILITY',
  UPDATE_WITHDRAWAL:'UPDATE_WITHDRAWAL',
}

let app_language_supports = [
  {
    id: 'zh_TW',
    value: 'hant',
    label: '繁體'
  },
  {
    id: 'zh_CN',
    value: 'hans',
    label: '简体'
  },
  {
    id: 'en_US',
    value: 'en',
    label: 'English'
  },
  {
    id: 'vi_VN',
    value: 'vi',
    label: 'Vietnam'
  }
]

export const APP_LANGUAGE_SUPPORTS = iTradeEnv.language.map(item => app_language_supports.find(v => v.id === item)).filter(Boolean)

export const APP_MODE_TYPE = {
  STANDALONE: 'standalone',
  EMBEDDED: 'embedded'
}

export const APP_THEME_SUPPORTS = ['light', 'dark']

export const FLASH_TYPE = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  INFO: 'info'
}

export const APP_STOCK_SETTING = {
  RED_RISE_GREEN_FALL: 'rise-red,fall-green',
  GREEN_RISE_RED_FALL: 'rise-green,fall-red'
}

export const DATE_PICKER_TYPE = {
  SINGLE_DATE: 2,
  MULTIPLE_DATE: 4,
  RANGE_DATE: 8,
  BARTHDAY_DATE:6
}

export const ORDER_TYPE = {
  ENHANCED_LIMIT_ORDER: { label: 'Enhanced Limit Order', value: 'E' },
  LIMIT_ORDER: { label: 'Limit Order', value: 'L' },
  TRIGGER_ORDER: { label: 'Trigger Order', value: 'P' },
  AT_AUCTION:{label: 'At Auction',value: 'A'},
  MARKET_ORDER:{label: 'Market Order',value: 'M'}
}

export const systemRqErr = {
  code: 6,
  status: 'ST500',
  result: {
    errorCode: 'OLS0003',
    errorMessage: ''
  }
}

export const CUSTOM_STYLES = {
  HEADER_NORMAL: {
    color: 'inherit',
    cursor: 'default'
  }
}

export const REFRESH_DATA = {
  CORPORATE_ACTION: 'CORPORATE_ACTION',
  IPO_ACTION: 'IPO_ACTION',
  ORDER_TABLE: 'ORDER_TABLE',
  MARKET_ACTION: 'MARKET_ACTION',
  ACCOUNT_ACTION: "ACCOUNT_ACTION"
}

export const BROWSER = {
  OPERA: 'Opera',
  FIREFOX: 'Firefox',
  SAFARI: 'Safari',
  EDGE: 'Edge',
  CHROME: 'Chrome',
  BLINK: 'Blink'
}

export const CA_MODE = {
  DETAIL_MODE: 'detail',
  CANCEL_MODE: 'cancel',
  AMEND_MODE: 'amend',
  REPLY_MODE: 'reply'
}

export const ORDER_MODE = {
  CREATE: 'CREATE',
  CANCEL: 'CANCEL',
  MODIFY: 'MODIFY',
  DETAIL: 'DETAIL'
}

export const NAVIGATE_TYPE = {
  GROUP: 2,
  ITEM: 4,
  ACTION: 8
}

export const IPO_MODE = {
  MARGIN_APPLY_ACTION: 'MA',
  APPLY_ACTION: 'A',
  MODIFY_ACTION: 'MO'
}

export const IPO_MODIFY_TYPE ={
  MODIFY_APPLY_IPO: 'MAI',
  MODIFY_MARGIN_IPO: 'MMI'
}

export const IPO_PLAN = {
  INTEREST_PLAN: "I",
  FIXED_PLAN: "F"
}

export const DATE_CONSTANT = {
  DAYS: 'd',
  MONTH: 'M',
  ADD: 1,
  SUBTRACT: 2
}

export const LANG_KEY = {
  VI: 'VI',
  CN: 'CN',
  HK: 'HK',
  EN: 'EN'
}

export const WS_LANG_KEY = {
  SC: 'sc',
  TC: 'tc',
  EN: 'en'
}

export const LOADING_TYPE = {
  TEXT: 'TEXT',
  SMALL_IMG: 'SMALL_IMG',
  BIG_IMG: 'BIG_IMG',
  SKELETON:'SKELETON'
}

export const STOP_TYPE_TYPE = [
  { label: 'order_stop_price_type_D', value: 'D' },
  { label: 'order_stop_price_type_U', value: 'U' },
]

export const WATCHLIST_DIALOG_ACTION = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DELETE: 'DELETE'
}

export const FUND_ACTION_TYPES = {
  SUBSCRIPTION: 'Subscription',
  REDEMPTION: 'Redemption'
}

export const FUND_ACTION_COLOR = {
  [FUND_ACTION_TYPES.SUBSCRIPTION]: 'blue',
  [FUND_ACTION_TYPES.REDEMPTION]: 'purple'
}